/** Minimum character count for a Guide page title. */
export const PAGE_TITLE_MIN_LENGTH = 1;
/** Maximum character count for a Guide page title. */
export const PAGE_TITLE_MAX_LENGTH = 60;
/** Minimum character count for a Guide page section title. */
export const SECTION_TITLE_MIN_LENGTH = 1;
/** Maximum character count for a Guide page section title. */
export const SECTION_TITLE_MAX_LENGTH = 200;

/** Minimum character count for a page/section short title (0 = optional). */
export const NODE_SHORT_TITLE_MIN_LENGTH = 0;
/** Maximum character count for a page/section short title. */
export const NODE_SHORT_TITLE_MAX_LENGTH = 60;

/** Minimum character count for image alt text (0 = optional). */
export const IMAGE_ALT_TEXT_MIN_LENGTH = 0;
/** Maximum character count for image alt text. */
export const IMAGE_ALT_TEXT_MAX_LENGTH = 500;

/** Minimum character count for an Epic title. */
export const EPIC_TITLE_MIN_LENGTH = 1;
/** Maximum character count for an Epic title. */
export const EPIC_TITLE_MAX_LENGTH = 200;
/** Minimum character count for an Epic description (0 = optional). */
export const EPIC_DESCRIPTION_MIN_LENGTH = 0;
/** Maximum character count for an Epic description. */
export const EPIC_DESCRIPTION_MAX_LENGTH = 2000;

/**
 * Returns true when the title's character length is within [minLength,
 * maxLength]. Callers should pass the already-converted plain text (e.g.
 * via useEntityConverter); this function does not strip markup.
 */
export function isWithinRange(title: string, minLength: number, maxLength: number): boolean {
  const length = title.length;
  return length >= minLength && length <= maxLength;
}

/** Subsection IDs allow only alphanumerics, hyphens, and underscores. */
const SUBSECTION_ID_PATTERN = /^[A-Za-z0-9_-]+$/;

/**
 * Returns true when the subsection ID is safe as an HTML `id` and `#fragment`
 * anchor: alphanumerics, hyphens, or underscores with no spaces. An empty
 * value is valid because it clears the ID.
 */
export function isValidSubsectionId(id: string): boolean {
  const trimmed = id.trim();
  return trimmed.length === 0 || SUBSECTION_ID_PATTERN.test(trimmed);
}
